import React from 'react';
import "./userInfo.scss"
import { Button } from 'react-bootstrap';
import { editModeOn } from '../../../../utilFunctions';
import { DATE_FORMAT, functionalities } from '../../../../consts';
import BackButton from '../../../../utilsComponent/BackButton';
import { getLocation } from '../ClaimForm/helper';
import { format } from 'date-fns';

const UserInfo = ({
  policyData,
  setShowPolicyDetails,
  setShowClaimForm
}) => {
  return (
    <>
    <div className='d-flex justify-content-between px-3 w-100 back mt-2'>
      <div>
      <BackButton handleBack={() => {setShowPolicyDetails(false)}}/>
      </div>
      <div className='mx-2'>
        {editModeOn(functionalities.CLAIM_CREATION) && 
        <Button className='btn btn-success' onClick={()=>{setShowClaimForm(true)}}>Raise New Claim</Button>
}
      </div>
    </div>
    <div className="profile-card">
      <h2 className="name">{policyData?.proposer_details
                            ? `${policyData.proposer_details.proposer_name || ""} ${policyData.proposer_details.lastname || ""}`.trim()
                            : "--"}</h2>
      <p className="info-line">
        <span>Customer ID: {policyData?.customer_ref_id || "--"}</span> | 
        <span>Location: {getLocation(policyData) || "--"}</span> | 
        <span>📞 {policyData?.customer_mobile || "--"}</span> 
        <span>DOB: {policyData?.proposer_details?.proposer_dob ? format(policyData?.proposer_details?.proposer_dob,DATE_FORMAT.DD_MM_YYYY) : "--"}</span>
      </p>
    </div>
    </>
  );
};

export default UserInfo;